module.exports = __webpack_public_path__ + "img/Trinity.cde8e51e.png";